// Filtri collezione: su desktop pannello sempre aperto e applicazione immediata; su mobile si applica col pulsante.
// L'ordinamento si applica subito ovunque. I campi prezzo vuoti non vengono inviati.
document.querySelectorAll('[data-facets-form]').forEach(function (form) {
  var panel = form.querySelector('[data-facets]');
  var wide = matchMedia('(min-width: 900px)');
  function sync() { if (panel && wide.matches) panel.open = true; }
  sync();
  wide.addEventListener('change', sync);
  form.classList.add('js-auto');
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]') || wide.matches) form.requestSubmit();
  });
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });
});
